import * as React from 'react'

import SimpleModal from './SimpleModal'
import DataTableForBlueprint from './DataTableForBlueprint'

import N from '../utils/assert-never'

import { IBlueprintService } from '../interfaces/services/blueprints'
import { Formatset } from '../interfaces/entities/formatset'
import { FormBlueprint } from '../interfaces/components/dynamic-form'

import DI from '../app/di'
import { translateWithUserLocale } from '../utils/i18n'

import { Button, Icon } from '@design/pt-ui'

export type Props = {
  formatset: Formatset
}

type State = {
  open: boolean
  blueprint: FormBlueprint | null
}

const initialState: State = {
  open: false,
  blueprint: null,
}

type Action =
  | { type: 'close' }
  | { type: 'open' }
  | { type: 'loaded_blueprint'; payload: FormBlueprint }

const reducer = (state: State, action: Action) => {
  if (action.type === 'open') {
    return {
      ...state,
      open: true,
    }
  }
  if (action.type === 'close') {
    return {
      ...state,
      open: false,
    }
  }
  if (action.type === 'loaded_blueprint') {
    return {
      ...state,
      loading: false,
      blueprint: action.payload,
    }
  }

  return N(action, state)
}

const FormatsetInformationModal = (props: Props) => {
  const blueprintService = DI.get('BlueprintService') as IBlueprintService

  const [state, dispatch] = React.useReducer(reducer, initialState)

  React.useEffect(() => {
    blueprintService
      .getFormatsetBlueprint(props.formatset.type, props.formatset.id)
      .then((blueprint) => {
        dispatch({ type: 'loaded_blueprint', payload: blueprint })
      })

    return () => {}
  }, [props.formatset.type]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Button
        disabled={state.blueprint == null}
        onClick={() => dispatch({ type: 'open' })}
        color="inherit">
        <Icon>settings</Icon>
      </Button>
      <SimpleModal
        width={'auto'}
        subtitle={translateWithUserLocale('formatset_info_modal.description')}
        title={translateWithUserLocale(
          'formatset_info_modal.formatset_configuration',
        )}
        open={state.open}
        onOpen={() => dispatch({ type: 'open' })}
        onClose={() => dispatch({ type: 'close' })}
        scroll="paper">
        {state.blueprint && (
          <DataTableForBlueprint
            data={props.formatset.data}
            blueprint={state.blueprint}
          />
        )}
      </SimpleModal>
    </>
  )
}

export default FormatsetInformationModal
